import React, { useState, useEffect, useCallback } from "react";
import MediaImagePicker from "../../media/image/image_picker";
import { create as createImage } from "../../media/image/axios";
import {
  montserratFontCssUrl,
  tinymceFontFamilyFormats,
} from "../helper";

const ControldocFormTemplateLayoutEditable = props => {
  const { editorRef, context, imagePicker } = props;
  const [openFilePicker, setOpenFilePicker] = useState(false);
  const imageTag = { height: "90px", width: "auto" };

  const insertImageInEditor = useCallback((editor, imageData) => {
    editor.insertContent(`
      <img
        src="${imageData.preview_url}"
        alt="${imageData.filename}"
        width="${imageTag.width}"
        height="${imageTag.height}"
      />`);
  }, []);

  const uploadMediaImageFile = useCallback((file) => {
    const formData = new FormData();
    formData.append("media_image[media]", file, file.name || "image");

    return new Promise((resolve, reject) => {
      createImage(formData, response => {
        if (response?.status === 201) {
          if (_.isFunction(imagePicker?.setImageList)) {
            imagePicker.setImageList(prev => [...prev, response.data]);
          }
          resolve(response.data);
        } else {
          const message = response?.data?.media?.[0] || "No se pudo subir la imagen";
          reject(message);
        }
      });
    });
  }, [imagePicker?.setImageList]);

  const configEditable = {
    selector: `.template-layout-${context}`,
    menubar: false,
    max_height: 200,
    language: "es",
    relative_urls: false,
    remove_script_host: false,
    entity_encoding: "raw",
    placeholder: `Configura tu ${context == "header" ? "Cabecera" : "Pie de Página"} del documento`,
    plugins: ["lists", "autolink", "table", "image"],
    toolbar: "fontfamily | bold italic underline forecolor backcolor | undo redo | link | table | alignleft aligncenter alignright alignjustify | uploadFile | numberPage",
    content_css: [montserratFontCssUrl],
    font_family_formats: tinymceFontFamilyFormats,
    table_toolbar: "tableprops",
    table_default_attributes: { border: "2" },
    table_default_styles: { width: "100%", "boder-color": "#000000", "border-style": "solid" },
    automatic_uploads: true,
    paste_data_images: true,
    images_file_types: "jpeg,jpg,png",
    images_upload_handler: (blobInfo, progress) => {
      return uploadMediaImageFile(blobInfo.blob())
        .then(imageData => imageData.preview_url)
        .catch(message => Promise.reject({ message, remove: true }));
    },
    setup: editor => {
      editor.on("init", () => { editorRef.current = editor });

      editor.on("drop", e => {
        const files = e.dataTransfer?.files;
        if (!files?.length) return;

        const imageFile = Array.from(files).find(file => file.type.startsWith("image/"));
        if (!imageFile) return;

        e.preventDefault();
        e.stopPropagation();

        uploadMediaImageFile(imageFile)
          .then(imageData => insertImageInEditor(editor, imageData))
          .catch(message => {
            editor.notificationManager.open({
              text: message,
              type: "error",
            });
          });
      });

      editor.ui.registry.addButton("uploadFile", {
        text: "Imágenes",
        icon: "image",
        onAction: () => {
          setOpenFilePicker(true);
        },
      });

      editor.ui.registry.addButton("numberPage", {
        text: "Número de página",
        onAction: () => {
          editor.insertContent("[[numberPage]]");
        },
      });
    },
  };

  useEffect(() => {
    tinyMCE.init(configEditable);

    return () => {
      try {
        tinyMCE.remove(`.template-layout-${context}`);
      } catch (error) {
        console.error(error);
      }
    };
  }, [context, uploadMediaImageFile, insertImageInEditor]);

  return (
    <>
      <MediaImagePicker
        openFilePicker={openFilePicker}
        setOpenFilePicker={setOpenFilePicker}
        imageList={imagePicker?.imageList}
        setImageList={imagePicker?.setImageList}
        tinymceEditor={editorRef.current}
        allowedFormatImagePicker={imagePicker?.allowedFormatFiles}
        imageTag={imageTag}
      />
      <div
        className={`template-layout-${context}`}
        dangerouslySetInnerHTML={{ __html: (props?.templateLayout || {})[context] }}
        style={{ border: "1px dashed", maxHeight: "200px" }}
      >
      </div>
    </>
  );
};

export default ControldocFormTemplateLayoutEditable;
